import React from 'react';
import { Link } from 'react-router';
import Events from '../components/Events';
import HeroCarousel from '../components/HeroCarousel';

const Home: React.FC = () => {
  return (
    <div className="pt-6 sm:pt-8">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pb-12">
        {/* Carrousel banner als binnenkomer */}
        <div className="mb-8 sm:mb-12">
          <HeroCarousel />
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 lg:gap-12">
          {/* Linker kolom met welkomsttekst */}
          <div className="lg:col-span-7 space-y-6 sm:space-y-8">
            <div>
              <h1 className="text-2xl sm:text-3xl font-bold text-gray-900 mb-4 sm:mb-6">
                Welkom bij Anshin, Aikido Vereniging Arnhem!
              </h1>
              
              {/* Aankondigingen */}
              <div className="bg-orange-50 border border-orange-200 rounded-lg p-4 mb-6">
                <p className="text-orange-800 font-medium">
                  <Link to="/aanmelden" className="text-orange-600 hover:text-orange-800 underline">
                    Meld je hier aan voor een gratis proefles
                  </Link>
                </p>
              </div>
              
              <h2 className="text-2xl font-semibold text-gray-800 mb-4">Wat is Aikido?</h2>
              <p className="text-gray-600 leading-relaxed mb-6">
                Aikido is een Japanse krijgskunst die begin 20e eeuw is ontwikkeld door O'Sensei Morihei Ueshiba. Hij had achtergrond in verschillende krijgskunsten waaronder jiu jitsu, speervechten en zwaardvechten, maar vond daar geen voldoening in. Hij had de behoefte de strijd van alsmaar 'winnen' versus 'verliezen' te overstijgen. O'sensei zei daarover: "als er een winnaar is, is er een verliezer, en als er een verliezer is, is de strijd nooit voorbij." Om een conflict echt effectief op te lossen, laat Aikido daarom geen geweld toe: niet naar jezelf, maar ook niet naar de ander.
              </p>
              <Link to="/achtergrond" className="link-primary">
                Benieuwd naar meer achtergrond? Klik hier →
              </Link>
            </div>

            <div>
              <h2 className="text-2xl font-semibold text-gray-800 mb-4">Anshin</h2>
              <p className="text-gray-600 leading-relaxed mb-6">
                'Shin' betekent hart, en 'Anshin' betekent gemoedsrust, vertrouwen. Het vinden van vertrouwen in jezelf, in de beweging, en uiteindelijk in het leven. Dat klinkt heel rustgevend, maar er gaat ook een enorme kracht vanuit. De kracht van een kalm hart, en van daaruit elke beweging van de ander ontvangen zonder je balans te verliezen. Zowel fysiek als mentaal, want conflictoplossend vermogen overstijgt de mat, en kan je in meer vlakken van je leven toepassen.
              </p>
            </div>

            <div>
              <h2 className="text-2xl font-semibold text-gray-800 mb-4">Aikidovereniging</h2>
              <p className="text-gray-600 leading-relaxed mb-4">
                Wij zijn bewust een vereniging, omdat Aikido verbindt. We zijn een gemeenschap die naast te trainen het ook leuk vindt om activiteiten te organiseren die verbinden. We borgen daarvoor een veilig leerklimaat waarin ieder zichzelf kan ontplooien. Benieuwd naar het lesaanbod? Of heb je een vraag?
              </p>
              <div className="flex items-center gap-4">
                <Link to="/lesaanbod" className="link-primary">
                  Bekijk ons lesaanbod →
                </Link>
                <span className="text-gray-400">|</span>
                <Link to="/praktisch" className="link-primary">
                  Stel een vraag →
                </Link>
              </div>
            </div>
          </div>

          {/* Rechter kolom met evenementen */}
          <div className="lg:col-span-5 lg:sticky lg:top-24">
            <Events />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Home;
